import { getObjKey } from "../utils";
import { formTypeEnum } from "../../application/enum";


const getDefaultValue2 = (formValues, formType, fieldName, shouldInitFieldAsObject = false) => {
    let whatForm = "";
    let defaultValue;
    switch (formType.toLowerCase()) {
        case formTypeEnum.unemploymentForm: {
            whatForm = getObjKey(formTypeEnum, formTypeEnum.unemploymentForm);
            break;
        }
        case formTypeEnum.workIncapacityForm: {
            whatForm = getObjKey(formTypeEnum, formTypeEnum.workIncapacityForm);
            break;
        }
        case formTypeEnum.hospitalisedForm: {
            whatForm = getObjKey(formTypeEnum, formTypeEnum.hospitalisedForm);
            break;
        }
        case formTypeEnum.step1: {
            whatForm = getObjKey(formTypeEnum, formTypeEnum.step1);
            break;
        }
        default:
            whatForm = "unemploymentForm";
    }
    if (whatForm) {
        if (formValues[whatForm] === undefined) {
            formValues[whatForm] = {};
        }
        if (shouldInitFieldAsObject && formValues[whatForm][fieldName] === undefined) {
            formValues[whatForm][fieldName] = {};
        }
        defaultValue = formValues[whatForm][fieldName];
    }
    return defaultValue;
};

export { getDefaultValue2, formTypeEnum }